import React, { Component } from 'react';
import PropTypes from 'prop-types';
import lodashIsEqual from 'lodash/fp/isEqual';

import moveElementInArray from 'common/util/moveElementInArray';
import SrMultiFileUploader from 'client/components/SrMultiFileUploader';
import ButtonDeprecated, {
  BUTTON_THEME_YELLOW,
} from 'client/components/ButtonDeprecated';

export const SR_ADMIN_PHOTOS_EDITOR_FILE_PATH_APARTMENT = '/apartment-uploads/photos/{uuid}';
export const SR_ADMIN_PHOTOS_EDITOR_FILE_PATH_APARTMENT_COMMUNITY_PHOTOS = '/apartment-uploads/photos/{uuid}';
export const SR_ADMIN_PHOTOS_EDITOR_FILE_PATH_FLOOR_PLAN = '/floor-plan-uploads/photos/{uuid}';

class SrAdminPhotosEditor extends Component {
  static propTypes = {
    photoUrls: PropTypes.array,
    onSave: PropTypes.func.isRequired,
    filePath: PropTypes.string.isRequired,
  }

  static defaultProps = {
    photoUrls: [],
  }

  constructor(props) {
    super(props);
    this.state = {
      editedPhotoUrls: props.photoUrls,
      isPhotosEdited: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { photoUrls } = this.props;
    if (!lodashIsEqual(photoUrls, nextProps.photoUrls)) {
      this.setState({
        editedPhotoUrls: nextProps.photoUrls,
        isPhotosEdited: false,
      });
    }
  }

  _movePhotoUrl = (e) => {
    e.preventDefault();
    const { photoUrl, direction: directionString } = e.target.dataset;
    const direction = parseInt(directionString, 10);
    const { photoUrls } = this.props;
    const { editedPhotoUrls } = this.state;
    const newPhotoUrls = moveElementInArray(editedPhotoUrls, photoUrl, direction);
    const isPhotosEdited = !lodashIsEqual(newPhotoUrls, photoUrls);

    this.setState({
      editedPhotoUrls: newPhotoUrls,
      isPhotosEdited: isPhotosEdited,
    });
  }

  _moveTo = (e) => {
    e.preventDefault();
    const { photoUrl, position } = e.target.dataset;
    const { editedPhotoUrls } = this.state;
    const { photoUrls } = this.props;

    const newPhotoUrls = editedPhotoUrls.slice();
    if (position === 'end') {
      newPhotoUrls.push(
        newPhotoUrls.splice(newPhotoUrls.indexOf(photoUrl), 1)[0]
      );
    }
    else if (position === 'start') {
      newPhotoUrls.unshift(newPhotoUrls.splice(newPhotoUrls.indexOf(photoUrl), 1)[0]);
    }
    const isPhotosEdited = !lodashIsEqual(newPhotoUrls, photoUrls);

    this.setState({
      editedPhotoUrls: newPhotoUrls,
      isPhotosEdited: isPhotosEdited,
    });
  }

  _remove = (e) => {
    e.preventDefault();
    const { editedPhotoUrls } = this.state;
    this.setState({
      editedPhotoUrls: editedPhotoUrls.filter((photoUrl) => {
        return photoUrl !== e.target.dataset.photoUrl;
      }),
      isPhotosEdited: true,
    });
  }

  _onPhotosUploaded = (photoUploadResults) => {
    const s3FileUrls = photoUploadResults.map(({ s3FileUrl }) => s3FileUrl);
    this.setState({
      editedPhotoUrls: [...s3FileUrls, ...this.state.editedPhotoUrls],
      isPhotosEdited: true,
    });
  }

  _onSave = (event) => {
    const { onSave } = this.props;
    const { editedPhotoUrls } = this.state;
    event.preventDefault();
    event.stopPropagation();
    onSave(editedPhotoUrls);
  }

  render() {
    const {
      editedPhotoUrls,
      isPhotosEdited,
    } = this.state;
    const {
      filePath,
    } = this.props;

    return (
      <div className='SrAdminPhotosEditor'>
        <SrMultiFileUploader
          accept='image/*'
          filePath={filePath}
          onFilesUploaded={this._onPhotosUploaded}
        />
        <div className='photosContainer'>
          {editedPhotoUrls.map((photoUrl, index) => (
            <div key={photoUrl} className='photoRow'>
              <img src={photoUrl} alt={index} />
              <br />
              <div className='photoActionContainer'>
                <span
                  className='button white small-admin'
                  data-photo-url={photoUrl}
                  onClick={this._remove}
                >
                  remove
                </span>
              </div>
              <div className='move'>
                <span
                  className='arrow-up'
                  data-photo-url={photoUrl}
                  data-direction={-1}
                  onClick={this._movePhotoUrl}
                />
                <span
                  className='arrow-down'
                  data-photo-url={photoUrl}
                  data-direction={1}
                  onClick={this._movePhotoUrl}
                />
              </div>
              <div className='moveTo'>
                <span
                  role='img'
                  className='moveToButton'
                  aria-label='moveToStart'
                  data-photo-url={photoUrl}
                  data-position='start'
                  onClick={this._moveTo}
                >
                  ⏫
                </span>
                <span
                  role='img'
                  className='moveToButton'
                  aria-label='moveToEnd'
                  data-photo-url={photoUrl}
                  data-position='end'
                  onClick={this._moveTo}
                >
                  ⏬
                </span>
              </div>
            </div>
          ))}
        </div>
        {isPhotosEdited && (
          <ButtonDeprecated
            type='button'
            theme={BUTTON_THEME_YELLOW}
            onClick={this._onSave}
            className='saveButton'
          >
            Save
          </ButtonDeprecated>
        )}
      </div>
    );
  }
}

SrAdminPhotosEditor.displayName = 'SrAdminPhotosEditor';

export default SrAdminPhotosEditor;
